<div *ngIf="params.data?.queue_ids && params.data?.has_qualification === 1" fxLayout="row" fxLayoutAlign="start center">
  <button *ngIf="!params.data.qualification" (click)="reQualify(params.data)" mat-icon-button color="warn" matTooltip="{{ 'stats.handled_call.qualify_call' | translate }}">
    <mat-icon>add_box</mat-icon>
  </button>
  <button *ngIf="params.data.qualification" (click)="reQualify(params.data)" mat-icon-button color="primary" matTooltip="{{ 'stats.handled_call.qualify_call' | translate }}">
    <mat-icon>edit</mat-icon>
  </button>
</div>
